// extracted by mini-css-extract-plugin
export default {"container":"matches_panel-module___container___fa319cc2","matchesList":"matches_panel-module___matchesList___f01f0023","matchesInfo":"matches_panel-module___matchesInfo___f3248587"};